/** @typedef {import('../domain/types.js').BehavioralCategory} BehavioralCategory */

/**
 * User-facing genre list for Category Picker (maps to internal BehavioralCategory).
 * @type {Array<{ id: string, label: string, behavioral: BehavioralCategory }>}
 */
export const PICKER_CATEGORIES = [
  { id: "manga_reading", label: "Manga & webtoon", behavioral: "manga_reading" },
  { id: "anime_streaming", label: "Anime streaming", behavioral: "anime_streaming" },
  { id: "shortform_feed", label: "Short-form & social", behavioral: "shortform_feed" },
  { id: "work_comms", label: "Work & messaging", behavioral: "work_comms" },
  { id: "gaming", label: "Gaming", behavioral: "gaming_session" },
  { id: "education", label: "Education", behavioral: "learning" },
  { id: "entertainment", label: "Entertainment", behavioral: "entertainment_discovery" },
  { id: "productivity", label: "Productivity", behavioral: "productivity" },
  { id: "news", label: "News", behavioral: "utility" },
  { id: "shopping", label: "Shopping", behavioral: "utility" },
  { id: "other", label: "Other", behavioral: "unknown" },
];

/**
 * @param {BehavioralCategory} behavioral
 * @returns {string}
 */
export function behavioralToPickerId(behavioral) {
  const hit = PICKER_CATEGORIES.find((p) => p.behavioral === behavioral);
  return hit?.id || "other";
}

/**
 * @param {string} pickerId
 * @returns {BehavioralCategory}
 */
export function pickerIdToBehavioral(pickerId) {
  const hit = PICKER_CATEGORIES.find((p) => p.id === pickerId);
  return hit?.behavioral || "unknown";
}

/**
 * @param {string} pickerId
 * @returns {string}
 */
export function pickerCategoryLabel(pickerId) {
  return PICKER_CATEGORIES.find((p) => p.id === pickerId)?.label || pickerId;
}
